export default __webpack_public_path__ + "static/media/ep4collage1.728390be.jpg";